var exports = {
  "kL": "xdde3148b--745839--container",
  "K2": "xdde3148b--745839--logo-container",
  "wm": "xdde3148b--745839--logo",
};

module.exports = exports;
